import { ERROR_TYPES } from '../constants';
import { resolveStepNameFromField } from './resolveStepNameFromField';

type FlattenedValidationError = {
  fieldName: string;
  stepName: ReturnType<typeof resolveStepNameFromField>;
  errorCode: string;
  errorType: (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const flattenValidationErrors = (errors: Record<string, unknown>, parentField = ''): FlattenedValidationError[] => {
  const flattened: FlattenedValidationError[] = [];

  Object.entries(errors).forEach(([fieldName, errorValue]) => {
    const resolvedFieldName = parentField ? `${parentField}.${fieldName}` : fieldName;

    if (typeof errorValue === 'string') {
      flattened.push({
        fieldName: resolvedFieldName,
        stepName: resolveStepNameFromField(resolvedFieldName),
        errorCode: errorValue,
        errorType: ERROR_TYPES.USER,
      });
      return;
    }

    if (Array.isArray(errorValue)) {
      errorValue.forEach((nestedError, index) => {
        if (typeof nestedError === 'string') {
          flattened.push({
            fieldName: `${resolvedFieldName}[${index}]`,
            stepName: resolveStepNameFromField(resolvedFieldName),
            errorCode: nestedError,
            errorType: ERROR_TYPES.USER,
          });
          return;
        }

        if (isRecord(nestedError)) {
          flattened.push(...flattenValidationErrors(nestedError, `${resolvedFieldName}[${index}]`));
        }
      });
      return;
    }

    if (isRecord(errorValue)) {
      flattened.push(...flattenValidationErrors(errorValue, resolvedFieldName));
    }
  });

  return flattened;
};

export const flattenFormikValidationErrors = (errors: Record<string, unknown>): FlattenedValidationError[] =>
  flattenValidationErrors(errors);
